import { Link, useLocation } from "react-router-dom";
import { LANGS, langFromPath, localizedPath } from "../i18n/lang";

// Route-based language switch (no localStorage) — changes the URL so each language has its
// own crawlable address. Rendered as the v2 segmented control (`.seg`, active segment `.on`).
export function LangSwitch({ className = "" }: { className?: string }) {
  const { pathname } = useLocation();
  const active = langFromPath(pathname);
  return (
    <div className={`seg${className ? " " + className : ""}`}>
      {LANGS.map((lng) => (
        <Link
          key={lng}
          to={localizedPath(pathname, lng)}
          className={active === lng ? "on" : undefined}
          aria-current={active === lng ? "true" : undefined}
        >
          {lng.toUpperCase()}
        </Link>
      ))}
    </div>
  );
}
